import axios from 'axios';
import { UserEntity } from '../models/entity/userEntity';

const API_URL = import.meta.env.VITE_API_URL;

export class UserService {
    static async getCurrentUser(token: string): Promise<UserEntity> {
        const response = await axios.get(`${API_URL}/api/user/me`, {
            headers: { Authorization: `Bearer ${token}` }
        });
        return new UserEntity(response.data);
    }

    static async useCredits(token: string, amount: number): Promise<UserEntity> {
        const response = await axios.post(`${API_URL}/api/user/credits/use`,
            { amount },
            { headers: { Authorization: `Bearer ${token}` } }
        );
        return new UserEntity(response.data);
    }

    static async addCredits(token: string, amount: number): Promise<UserEntity> {
        const response = await axios.post(`${API_URL}/api/user/credits/add`,
            { amount },
            { headers: { Authorization: `Bearer ${token}` } }
        );
        return new UserEntity(response.data);
    }

    static async onboardUser(token: string, data: any): Promise<UserEntity> {
        const response = await axios.post(`${API_URL}/api/user/onboarding`,
            data,
            { headers: { Authorization: `Bearer ${token}` } }
        );
        return new UserEntity(response.data);
    }

    static async requestPasswordReset(email: string): Promise<void> {
        await axios.post(`${API_URL}/api/auth/forgot-password`, { email });
    }

    static async resetPassword(token: string, newPassword: string): Promise<void> {
        await axios.post(`${API_URL}/api/auth/reset-password`, {
            token,
            newPassword
        });
    }

    static async updateProfile(token: string, profileData: any): Promise<UserEntity> {
        const response = await axios.put(`${API_URL}/api/user/profile`,
            profileData,
            { headers: { Authorization: `Bearer ${token}` } }
        );
        return new UserEntity(response.data);
    }

    static async createDailyReading(token: string, payload: any): Promise<any> {
        const response = await axios.post(`${API_URL}/api/tarot/daily-reading`,
            payload,
            { headers: { Authorization: `Bearer ${token}` } }
        );
        return response.data;
    }
}
